import { type Analytics } from '@1debit/analytics';
import { createContext, type PropsWithChildren } from 'react';

export type AnalyticsId = string | null;

type AnalyticsContextType = {
	handler: Analytics;
	location: string;
};

export const AnalyticsContext = createContext<AnalyticsContextType | null>(null);

type Props = {
	handler: Analytics;
	location: string;
};

export function AnalyticsProvider({ children, handler, location }: PropsWithChildren<Props>) {
	return <AnalyticsContext.Provider value={{ handler, location }}>{children}</AnalyticsContext.Provider>;
}
